import * as THREE from 'three'
require('three-orbitcontrols');
import PolyBool from '../../../views/doodle3d/libs/polybooljs';

import tidepool_negx_2 from '@/3dapps/skybox/tidepool/negx_2.jpg';
import tidepool_negy_2 from '@/3dapps/skybox/tidepool/negy_2.jpg';
import tidepool_negz_2 from '@/3dapps/skybox/tidepool/negz_2.jpg';
import tidepool_posx_2 from '@/3dapps/skybox/tidepool/posx_2.jpg';
import tidepool_posy_2 from '@/3dapps/skybox/tidepool/posy_2.jpg';
import tidepool_posz_2 from '@/3dapps/skybox/tidepool/posz_2.jpg';


export var scene;//相机
export var camera;//场景
export var renderer;//渲染器
export let controls;
export let currentMesh;
let renderCount = -1;


const material = new THREE.MeshPhongMaterial({
    reflectivity: 1
});

function incRenderCount() {
    renderCount += 2;
}

function addSkyBox(scene, imgs) {
    new THREE.CubeTextureLoader().load(imgs, function (texture) { scene.background = texture; incRenderCount(); });
}

export function initThree(canvas) {
    let canvas_bound = canvas.getBoundingClientRect();
    scene = new THREE.Scene(); //相机

    //创建3D世界
    let w = canvas_bound.width;
    let h = canvas_bound.height;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true, //抗锯齿
        preserveDrawingBuffer: true, //3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#778A99")); //把渲染器的背景变成白色
    renderer.setPixelRatio(2);


    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(70, w / h, 0.1, 42000);
    //定义相机的x,y,z位置
    camera.position.set(88.62877672454879, 111.78596981662761, -101.28758498602225);
    camera.lookAt(scene.position); //把相机的位置渲染到场景中

    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas);
    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 0;
    controls.maxDistance = 22000;

    // let axesHelper = new THREE.AxesHelper(100);
    // scene.add(axesHelper);

    controls.addEventListener("change", function () {
        renderCount += 2;
        // console.log(camera.position.x, camera.position.y, camera.position.z);
    });

    // 灯光
    function addLights() {
        // 平行光
        let dirLight = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight.position.set(-30, 30, -30); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight);

        let dirLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight2.position.set(30, 30, 50);
        scene.add(dirLight2);

        // // 点光源
        // let light = new THREE.PointLight(0xffffff, 0.6, 100);
        // light.position.set(0, 0, 0);
        // scene.add(light);

        // 环境光
        let ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
        scene.add(ambientLight);
    }
    addLights();

    addSkyBox(scene, [
        tidepool_negx_2,
        tidepool_posx_2,
        tidepool_posy_2,
        tidepool_negy_2,
        tidepool_negz_2,
        tidepool_posz_2,
    ]);


    //渲染场景
    function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
    }
    animate();
}

export function updateBox(box) {
    if (currentMesh) {
        scene.remove(currentMesh);
        currentMesh = null;
    }
    makeBox(box);
}

function generalEquation(first_x, first_y, second_x, second_y) {
    // 一般式 Ax+By+C=0
    // from http://www.cnblogs.com/DHUtoBUAA/
    let A = second_y - first_y;
    let B = first_x - second_x;
    let C = second_x * first_y - first_x * second_y;
    return { A, B, C };
}

function getIntersectPointofLines(x1, y1, x2, y2, x3, y3, x4, y4) {
    // from http://www.cnblogs.com/DHUtoBUAA/
    let { A: A1, B: B1, C: C1 } = generalEquation(x1, y1, x2, y2);
    let { A: A2, B: B2, C: C2 } = generalEquation(x3, y3, x4, y4);
    let m = A1 * B2 - A2 * B1;
    let x = 0, y = 0;
    if (m == 0) {
        console.error("平行，无交点");
    } else {
        x = (C2 * B1 - C1 * B2) / m;
        y = (C1 * A2 - C2 * A1) / m;
    }
    return { x, y };
}

function makeShape(vertexes) {
    let shape = new THREE.Shape();

    shape.moveTo(vertexes[vertexes.length - 1].x, vertexes[vertexes.length - 1].y);
    vertexes.forEach(v => {
        shape.lineTo(v.x, v.y);
    });

    return shape;
}

const cubicleMaker = [
    function (boxData) {
        const t_2 = boxData.size.t * 0.5;
        const w = boxData.size.w;
        const h = boxData.size.h;
        return {
            regions: [
                [
                    [-w, -t_2],
                    [-t_2, -t_2],
                    [-t_2, -h],
                    [t_2, -h],
                    [t_2, -t_2],
                    [w, -t_2],
                    [w, t_2],
                    [t_2, t_2],
                    [t_2, h],
                    [-t_2, h],
                    [-t_2, t_2],
                    [-w, t_2]
                ],
            ],
            inverted: false
        }
    },
    function (boxData) {
        const t_2 = boxData.size.t * 0.5;
        const w = boxData.size.w;
        const h = boxData.size.h;
        return {
            regions: [
                [
                    [-t_2, -h],
                    [t_2, -h],
                    [t_2, h],
                    [-t_2, h]
                ],
            ],
            inverted: false
        }
    },
    function (boxData) {
        const t_2 = boxData.size.t * 0.5;
        const w = boxData.size.w;
        const h = boxData.size.h;
        return {
            regions: [
                [
                    [-w, -t_2],
                    [w, -t_2],
                    [w, t_2],
                    [-w, t_2]
                ],
            ],
            inverted: false
        }
    },
    function (boxData) {
        const t_2 = boxData.size.t * 0.5;
        const w = boxData.size.w;
        const h = boxData.size.h;
        return {
            regions: [
                [
                    [-t_2, -h],
                    [t_2, -h],
                    [t_2, -t_2],
                    [w, -t_2],
                    [w, t_2],
                    [t_2, t_2],
                    [t_2, h],
                    [-t_2, h]
                ],
            ],
            inverted: false
        }
    },
];


function makeBox(box) {
    let size = box.size;
    let closeTop = box.closeTop;

    // 底
    let startAngle = Math.PI / box.edge;
    let vertexes = [];
    let angleStep = startAngle * 2;
    for (let i = 0, angle = startAngle; i < box.edge; i++, angle += angleStep) {
        vertexes.push({
            x: size.w * Math.cos(angle) * 0.5,
            y: size.h * Math.sin(angle) * 0.5,
        });
    }

    let base = makeShape(vertexes);

    var baseGeom = new THREE.ExtrudeBufferGeometry(base, {
        depth: size.t,
        bevelEnabled: false
    });

    // 壁
    let innerVertexes = [];
    let v2 = vertexes[vertexes.length - 1];
    let v3 = vertexes[vertexes.length - 2];
    vertexes.forEach(v => {
        let u1 = { x: v2.x - v.x, y: v2.y - v.y };
        let u2 = { x: v3.x - v2.x, y: v3.y - v2.y };
        let u1Len = Math.sqrt(u1.x ** 2 + u1.y ** 2);
        let u2Len = Math.sqrt(u2.x ** 2 + u2.y ** 2);
        // 归一化
        u1.x /= u1Len; u1.y /= u1Len;
        u2.x /= u2Len; u2.y /= u2Len;
        // 旋转90度
        let w1 = { x: -u1.y * size.t, y: u1.x * size.t };
        let w2 = { x: -u2.y * size.t, y: u2.x * size.t };
        let p1 = { x: v.x - w1.x, y: v.y - w1.y };
        let p2 = { x: v2.x - w1.x, y: v2.y - w1.y };
        let p3 = { x: v2.x - w2.x, y: v2.y - w2.y };
        let p4 = { x: v3.x - w2.x, y: v3.y - w2.y };
        let inter = getIntersectPointofLines(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y, p4.x, p4.y);
        innerVertexes.push(inter);

        v3 = v2;
        v2 = v;
    });
    // 初始的内部点，第一项实际上对应着外面点的最后一项。
    innerVertexes.push(innerVertexes.shift());

    let group = new THREE.Group();

    let innerShape = makeShape(innerVertexes);
    let outerShape = base.clone();
    outerShape.holes.push(innerShape);
    let boardGeom = new THREE.ExtrudeBufferGeometry(outerShape, {
        depth: size.d,
        bevelEnabled: false
    });
    let boardMesh = new THREE.Mesh(boardGeom, material);
    group.add(boardMesh);

    let baseMesh = new THREE.Mesh(baseGeom, material);
    group.add(baseMesh);

    if (closeTop) {
        let part1 = new THREE.ExtrudeBufferGeometry(base, {
            depth: size.t,
            bevelEnabled: false
        });
        let part2 = new THREE.ExtrudeBufferGeometry(innerShape, {
            depth: size.t,
            bevelEnabled: false
        });
        part2.translate(0, 0, size.t);
        let topMesh1 = new THREE.Mesh(part1, material);
        let topMesh2 = new THREE.Mesh(part2, material);
        let topMesh = new THREE.Group();
        topMesh.add(topMesh1);
        topMesh.add(topMesh2);
        topMesh.position.set(- 10, - 10, size.d + 4);
        group.add(topMesh);
    }

    if (box.cubicle > 0) {
        // 计算隔间
        let innerPoly = {
            regions: [
                innerVertexes.map(p => [p.x, p.y])
            ],
            reversed: false
        };
        let rawCubiclePoly = cubicleMaker[box.cubicle - 1](box);
        let cubiclePoly = PolyBool.intersect(innerPoly, rawCubiclePoly);
        let cubicleVertexes = cubiclePoly.regions[0].map(p => ({ x: p[0], y: p[1] }));
        let cubicleShape = makeShape(cubicleVertexes);
        let cubicleGeom = new THREE.ExtrudeBufferGeometry(cubicleShape, {
            depth: size.d - size.t,
            bevelEnabled: false
        });
        let cubicleMesh = new THREE.Mesh(cubicleGeom, material);
        group.add(cubicleMesh);
    }

    group.rotation.x = Math.PI * 1.5;
    group.position.y = - size.d * 0.5;

    scene.add(group);

    currentMesh = group;
}





// WEBPACK FOOTER //
// ./src/views/box3d/scripts/initThree.js